import React from "react";
import PropTypes from "prop-types";

import MaterialIcon from "shared/react_components/MaterialIcon";

const HttpStatusIcon = ({ statusCode }) => {
  const props =
    statusCode && statusCode[0] === "2"
      ? { name: "check", className: "text-success" }
      : { name: "close", className: "text-danger" };

  return <MaterialIcon {...props} />;
};

HttpStatusIcon.propTypes = {
  statusCode: PropTypes.string
};

export default HttpStatusIcon;
